import { useEffect, useMemo } from 'react';

import { GetLevels } from '@/api/fe-api/view/queries/capacity-evalution/get-levels';
import { FieldSelect } from '@/components/looker/field-select';

import { capitalizeFirstLetter } from '../../utils';

export type LevelSelectProps = {
  jobId: string;
  value?: string;
  onChange: (v: string) => void;
};
export function LevelSelect({ jobId, value, onChange }: LevelSelectProps) {
  const levels = GetLevels.useQuery({ jobId });
  const sortedLevels = useMemo(
    () => (levels.data?.isOk() ? [...levels.data.value].reverse() : []),
    [levels.data],
  );

  useEffect(() => {
    if (sortedLevels.length > 0) {
      onChange(sortedLevels[0]);
    }
  }, [sortedLevels, onChange]);

  return (
    <FieldSelect
      className="w-full max-w-[160px]"
      options={sortedLevels.map((level) => ({
        value: level,
        label: capitalizeFirstLetter(level),
      }))}
      type="number"
      label="Level"
      value={value}
      onChange={(v) => onChange(v)}
    />
  );
}
